export const promoClickEvent = (event) => {
  event.preventDefault();
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('promotion.click');
  }
};
